(function () {
    var MOBILE_WIDTH_SIZE = 1024;

    /* 제이쿼리 이징 */
    $.easing.easeOutQuad = function (a, b, c, d, e) {
        return -d * (b /= e) * (b - 2) + c;
    };



    $(window).ready(function () {
        // S : 내일배송 툴팁 활성
        $('.prd-tooltip-item .tag.tomorrow').click(function() {
            $(this).closest('.product-items').find('.tooltip-box').removeClass('active');
            // $(this).parents().find('.tooltip-box').removeClass('active');
            $(this).next('.tooltip-box.tomorrow').addClass('active');
        });
        $('.prd-tooltip-item .tooltip-box.tomorrow .btn-close').click(function() {
            $(this).closest('.product-items').find('.tooltip-box').removeClass('active');
            // $(this).parents().removeClass('active');
        });
        // E : 내일배송 툴팁 활성
    });
})();
$(function () {
    var bestDealswiper = null;
    function initBestdealSwiper(params) {
        if (bestDealswiper) {
            bestDealswiper.destroy(true, true);
            bestDealswiper = null;
        }
        // 768px 이상일 때만 생성
        if (window.innerWidth >= 768 && $('.best-deal-swiper-wrap .swiper').length > 0) {
            bestDealswiper = new Swiper('.best-deal-swiper-wrap .swiper', params || {
                scrollbar: {
                    el: ".swiper-scrollbar",
                },
                navigation: {
                    nextEl: ".best-deal-swiper-wrap .swiper-button-next",
                    prevEl: ".best-deal-swiper-wrap .swiper-button-prev",
                },
                loop: false,
                slidesPerView: 5,
                slidesPerGroup: 5,
                spaceBetween: 14,
                watchSlidesProgress: true,
                breakpoints: {
                    1380: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                    },
                    1080: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                },
            });
        }
    }
    initBestdealSwiper();

    var resizeTimer = null;
    function handleResize() {
        if (resizeTimer) {
            clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(function() {
            initBestdealSwiper();
        }, 200);
    }
    $(window).off('resize.storyHome').on('resize.storyHome', handleResize);
})



